// extracted by mini-css-extract-plugin
export default {"wrapper":"customRadio_wrapper__2iDQT"};